/** @format */

export const KEY_APP_NAME = "Interventi in Fune";
export const KEY_ASSISTANCE_MAIL = "produzione@infcom.it";
